module.exports = __webpack_public_path__ + "static/media/game-loading.9f970096.png";